module.exports = "<p>\n  show-device works!\n</p>\n"